<template>
  <EditFormDialog
    :formData="formData"
    :rules="rules"
    :formType="'add'"
    :loading="loading"
    :labelWidth="'150px'"
    :inputWidth="'300px'"
    @submitForm="submitForm"
    @closeDialog="closeDialog"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-form-item label="运营商"  prop="operatorId">
      <el-cascader size="mini" ref="cascader" placeholder="运营商" filterable
                   :options="operatorsTree" clearable
                   :props="{ checkStrictly:true,expandTrigger:'hover'}" :show-all-levels="false"
                   change-on-select @change='addHandOperator' v-model="formData.operatorId">
      </el-cascader>
    </el-form-item>
    <el-form-item label="场站名称" :label-width="formLabelWidth" prop="stationId">
      <el-select placeholder="场站名称" v-model="formData.stationId" @change="stationSelect">
        <el-option v-for="item in stationsForSelect" :key="item.id" v-bind:label="item.stationName" v-bind:value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="供电局电费" :label-width="formLabelWidth" prop="electricityFee">
      <el-input v-model="formData.electricityFee" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="运营成本" :label-width="formLabelWidth" prop="operatingCosts">
      <el-input v-model="formData.operatingCosts" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="分润开始时间" :label-width="formLabelWidth" prop="profitStartTime">
      <el-date-picker v-model="formData.profitStartTime"  v-if="formData.profitStartTime" :disabled="true" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="分润开始时间"></el-date-picker>
    </el-form-item>
    <el-form-item label="分润结束时间" :label-width="formLabelWidth" prop="profitEndTime">
      <el-date-picker v-model="formData.profitEndTime"  type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="分润结束时间"></el-date-picker>
    </el-form-item>
    <el-form-item label="备注" prop="remarks">
      <el-input v-model="formData.remarks" maxlength="1000" type="textarea" show-word-limit style="width:90%" autocomplete="off" placeholder="备注：实际电费xx元，运营费xx元" clearable></el-input>
    </el-form-item>
  </EditFormDialog>
</template>
<script>
  import api from '@/module/resourceCenter/api/handProfit.js'
  import EditFormDialog from '@/components/EditFormDialog'
  import commonApi from "@/module/resourceCenter/api/commonApi";
  import {isInteger} from '@/common/validator.js'

  export default {
    props: {
      operatorsTree: {
        type: Array,
        required: true
      }
    },
    components: {
      EditFormDialog
    },
    data() {
      const cForm = {
        operatorId: '',
        name: null,
        amount: null
      }
      return {
        formLabelWidth: '150px',
        station: null,
        loading: false, // 是显示加载
        searchLoading: false,
        stationsForSelect: {},
        // 表单
        cForm: cForm,
        formData: Object.assign({}, cForm),
        // rules表单验证
        rules: {
          stationId: [{required: true, message: "请选择分润场站", trigger: 'blur'}],
          operatorId: [{required: true, message: "请选择运营商", trigger: 'blur'}],
          electricityFee: [{required: true, message: "请设置供电局电费", trigger: 'blur'}],
          profitStartTime: [{required: true, message: "请选择支持手动分润场站", trigger: 'blur'}],
          profitEndTime: [{required: true, message: "请选择分润结束时间", trigger: 'blur'}],
        }
      }
    },
    created() {
    },
    computed: {},
    watch: {},
    methods: {
      //新增选择运营商
      addHandOperator(value){
        console.log("value:"+JSON.stringify(value))
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.formData.operatorId = operatorId
        commonApi.stationsForSelectByOperatorId(value).then((res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data;
          }
        });
        this.$refs.cascader.dropDownVisible = false
      },
      stationSelect() {
        this.stationsForSelect.forEach(item => {
          if (item.id === this.formData.stationId) {
            if(item.isProfit === 'Y' && item.timelyProfit === 'N' && item.handProfitTime){
              this.formData.profitStartTime =  item.handProfitTime
            }else{
              this.$message({
                type: 'error',
                message: "请检查场站是否支持分润、及时分润为否、分润开始时间不为空！"
              })
            }
          }
        });
      },
      // 关闭弹框
      closeDialog() {
        this.resetForm()
        this.$emit('closeDialog', 'add')
      },
      // 重置表单
      resetForm() {
        this.formData.operatorId = null
        this.formData = JSON.parse(JSON.stringify(this.cForm))
      },
      // 编辑、添加提交方法
      submitForm() {
        this.loading = true
        console.info("formData:"+JSON.stringify(this.formData))
        api.insert(this.formData).then((res) => {
          this.$message({
            type: 'success',
            message: this.$t('paramMonitor.message19')
          })
          this.resetForm()
          this.$emit('afterAdd')
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/handProfit/add.vue